import { DEMOGRAPHIC_VISIBILITY_FIELDS } from "../constants/demographicOptions";

const responseOnlyIdFields = [
  "educations",
  "employmentHistory",
  "licenses",
  "desiredSpecializations",
];

const withoutResponseId = (rows) => rows.map(({ id: _id, ...row }) => row);

const withoutResponseIds = (profile) => {
  const normalized = { ...profile };

  for (const field of responseOnlyIdFields) {
    if (Array.isArray(normalized[field])) {
      normalized[field] = withoutResponseId(normalized[field]);
    }
  }

  if (normalized.dualRoleExtras?.newCurrentSpecializations) {
    normalized.dualRoleExtras = {
      ...normalized.dualRoleExtras,
      newCurrentSpecializations: withoutResponseId(
        normalized.dualRoleExtras.newCurrentSpecializations,
      ),
    };
  }

  return normalized;
};

const normalizeDemographics = (demographics) => {
  const normalized = { ...demographics };

  for (const [answerField, visibilityField] of Object.entries(
    DEMOGRAPHIC_VISIBILITY_FIELDS,
  )) {
    if (
      Array.isArray(normalized[answerField]) &&
      !normalized[answerField].length
    ) {
      normalized[visibilityField] = false;
    }
  }

  return normalized;
};

export const buildCanonicalProfileUpdate = (updatedFields) => {
  const { demographics, ...rawProfile } = updatedFields;
  const profile = withoutResponseIds(rawProfile);

  return {
    ...(Object.keys(profile).length ? { profile } : {}),
    ...(demographics
      ? { demographics: normalizeDemographics(demographics) }
      : {}),
  };
};
